import type { ComponentProps } from "react";

const ArrowIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="currentColor"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.33333 0.666504L1 3.99984M4.33333 7.33317L1 3.99984M1 3.99984H9"
        stroke={props.stroke || "#183E7A"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowIcon;
